export const ROUTE_SETTINGS = '/settings';

/** The Settings tab for the organization itself, beside one tab per legal entity. */
export const ORGANIZATION_TAB_ID = 'organization';
